import React from 'react';
import * as S from './styles';

var TextFieldInputIcon = function TextFieldInputIcon(_ref) {
  var children = _ref.children;
  return React.createElement(S.TextFieldIconWrapper, null, children);
};

export { TextFieldInputIcon };